export enum WREX_PLAY_VIDEO {
    /**
     * @value Pick from gallery
     * @description Text used for example to label a button inviting the user to choose a video in the video gallery.
     */
    PICK_FROM_VIDEO_GALLERY = 'PLAY.PICK_VIDEO_FROM_GALLERY',
}
